var render = function () {
  var _vm$fetchedPontos;

  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('b-row', [_c('b-col', [_c('b-card', {
    staticClass: "header-marcar_consulta bg-gradient-primary"
  }, [_c('b-row', {
    attrs: {
      "align-v": "center"
    }
  }, [_c('b-col', {
    attrs: {
      "lg": "3"
    }
  }, [_c('h1', [_c('feather-icon', {
    staticClass: "mr-50",
    attrs: {
      "icon": "AwardIcon",
      "size": "30"
    }
  }), _vm._v(" Pontos Manuais ")], 1)]), _c('b-col', {
    attrs: {
      "lg": "6"
    }
  }, [_c('b-form', {
    on: {
      "submit": function submit($event) {
        $event.preventDefault();
        return _vm.fetchPontos.apply(null, arguments);
      }
    }
  }, [_c('b-input-group', {
    staticClass: "input-group-merge"
  }, [_c('b-input-group-prepend', {
    attrs: {
      "is-text": ""
    }
  }, [_c('feather-icon', {
    attrs: {
      "icon": "SearchIcon"
    }
  })], 1), _c('b-form-input', {
    attrs: {
      "placeholder": "Buscar pontos manuais"
    },
    model: {
      value: _vm.filtro.search,
      callback: function callback($$v) {
        _vm.$set(_vm.filtro, "search", $$v);
      },
      expression: "filtro.search"
    }
  })], 1)], 1)], 1), _c('b-col', {
    attrs: {
      "lg": "3"
    }
  }, [_c('b-button', {
    attrs: {
      "variant": "primary button-right",
      "to": '/PontosManuais/cadastrar'
    }
  }, [_vm._v(" Adicionar Pontos")])], 1)], 1)], 1)], 1)], 1), _c('b-card', {
    staticClass: "mb-0",
    attrs: {
      "no-body": ""
    }
  }, [_c('b-table', {
    ref: "refPontosListTable",
    staticClass: "position-relative",
    staticStyle: {
      "min-height": "50vw"
    },
    attrs: {
      "items": (_vm$fetchedPontos = _vm.fetchedPontos) === null || _vm$fetchedPontos === void 0 ? void 0 : _vm$fetchedPontos.content,
      "responsive": "",
      "fields": _vm.tableColumns,
      "primary-key": "id",
      "sort-by": _vm.sortBy,
      "show-empty": "",
      "empty-text": "Não há pontos manuais cadastrados",
      "sort-desc": _vm.isSortDirDesc
    },
    on: {
      "update:sortBy": function updateSortBy($event) {
        _vm.sortBy = $event;
      },
      "update:sort-by": function updateSortBy($event) {
        _vm.sortBy = $event;
      },
      "update:sortDesc": function updateSortDesc($event) {
        _vm.isSortDirDesc = $event;
      },
      "update:sort-desc": function updateSortDesc($event) {
        _vm.isSortDirDesc = $event;
      }
    },
    scopedSlots: _vm._u([{
      key: "cell(dataCriacao)",
      fn: function fn(data) {
        return [_vm._v(" " + _vm._s(_vm.formatDate(data.item.dataCriacao)) + " ")];
      }
    }, {
      key: "cell(dataInsercao)",
      fn: function fn(data) {
        return [_vm._v(" " + _vm._s(_vm.formatDate(data.item.dataInsercao)) + " ")];
      }
    }, {
      key: "cell(motivo)",
      fn: function fn(data) {
        return [_c('b-badge', {
          attrs: {
            "variant": "info"
          }
        }, [_vm._v(" " + _vm._s(data.item.motivo) + " ")])];
      }
    }, {
      key: "cell(pontuacao)",
      fn: function fn(data) {
        return [_c('b-badge', {
          attrs: {
            "variant": "primary"
          }
        }, [_vm._v(" " + _vm._s(data.item.pontuacao !== null && data.item.pontuacao !== undefined ? data.item.pontuacao.toFixed(1) : '-') + " ")])];
      }
    }, {
      key: "cell(actions)",
      fn: function fn(data) {
        return [_c('b-dropdown', {
          attrs: {
            "variant": "link",
            "no-caret": "",
            "right": _vm.$store.state.appConfig.isRTL
          },
          scopedSlots: _vm._u([{
            key: "button-content",
            fn: function fn() {
              return [_c('feather-icon', {
                staticClass: "align-middle text-body",
                attrs: {
                  "icon": "MoreVerticalIcon",
                  "size": "16"
                }
              })];
            },
            proxy: true
          }], null, true)
        }, [_c('b-dropdown-item', {
          attrs: {
            "to": {
              name: 'PontosManuaisEditar',
              params: {
                id: data.item.id
              }
            }
          }
        }, [_c('feather-icon', {
          attrs: {
            "icon": "EditIcon"
          }
        }), _c('span', {
          staticClass: "align-middle ml-50"
        }, [_vm._v("Editar")])], 1), _c('b-dropdown-item', {
          on: {
            "click": function click($event) {
              return _vm.deletePonto(data.item);
            }
          }
        }, [_c('feather-icon', {
          attrs: {
            "icon": "TrashIcon"
          }
        }), _c('span', {
          staticClass: "align-middle ml-50"
        }, [_vm._v("Excluir")])], 1)], 1)];
      }
    }])
  })], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }